export default "__VITE_ASSET__6e047315__"